import React from 'react';
import { motion } from 'framer-motion';
export function SocialProof() {
  const stats = [{
    value: '+300',
    label: 'manicuristas confían'
  }, {
    value: '6',
    label: 'Tomos del sistema'
  }, {
    value: '4.9/5',
    label: 'calificación ⭐'
  }, {
    value: '6',
    label: 'Bonos incluidos'
  }];
  return <section className="py-8 border-y border-dark-border bg-dark-card/50" data-id="element-230">
      <div className="max-w-6xl mx-auto px-4" data-id="element-231">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center" data-id="element-232">
          {stats.map((stat, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="flex flex-col items-center" data-id="element-233">
              <span className="text-3xl md:text-4xl font-black text-white mb-1" data-id="element-234">
                {stat.value}
              </span>
              <span className="text-sm text-gray-400 font-medium uppercase tracking-wider" data-id="element-235">
                {stat.label}
              </span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}